<template>
  <div class="main_box">
    <div class="top">
      <topBar class="topBar" />
    </div>
    <div class="blank_height" />
    <div class="appmain_box">
      <router-view class="appmain" />
    </div>
  </div>
</template>

<script>
import topBar from './topBar'
export default {
  components: {
    topBar
  },
  data() {
    return {
      worker_type: localStorage.getItem('_yixiang_agent_worker_type'),
      title: '',
      tabIndex: 0,
      showList: false
    }
  },
  mounted() {
    this.tabIndex = this.$route.path == '/index/body1' ? '0' : this.$route.path == '/index/management' ? '1' : this.$route.path == '/index/Order' ? '2' : '3'
  },
  methods: {
    handleCommand(command) {
      if (command == 'a') {
        // localStorage.removeItem('_yixiang_daili_token')
        this.goto('/')
      }
      if (command == 'b') {
        this.$router.push('/index/update_password')
      }
    },
    show_List() {
      this.showList = !this.showList
    },
    gettltle(msg) {
      console.log('父组件', msg)
      this.title = msg
    },
    goto(path) {
      console.log(path)
      this.tabIndex = path

      if (path == '0') {
        this.$router.push('/index/body1')
      } else if (path == 1) {
        this.$router.push('/index/management')
      } else if (path == 2) {
        this.$router.push('/index/Order')
      } else {
        this.$router.push('/index/copyright')
      }
      this.showList = false
    }
  }
}
</script>

<style scoped>
.blank_height {
  height: 88px;
}
.main_box {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
}

.main_box .top {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #f3f3f3;
}

.appmain {
  height: 100%;
  overflow: auto;
  max-width: 1440px;
  margin: 0 auto;
  padding-left: -100px;
}

.appmain_box {
  width: 100%;
}

.mobile_navList {
  display: none;
}
.mobile_topList {
  display: none;
  border: 1px solid #f2f2f2;
}

</style>
